import { FC, useState } from 'react';
import { Input, InputProps } from 'antd';
import { LoginType } from '../Login/type';
import { useCountDown } from 'ahooks';
import useI18n from '../../hooks/useI18n';

export interface IVerificationCodeInputProps extends InputProps {
  sendSMS: () => Promise<void>;
}

export const VerificationCodeInput: FC<IVerificationCodeInputProps> = (
  props,
) => {
  const { sendSMS, ...InputProps } = props;

  const [targetDate, setTargetDate] = useState<number>();
  const [countdown] = useCountDown({
    targetDate,
  });

  const i18n = useI18n();

  const getSub = async () => {
    if (countdown !== 0) {
      return;
    }
    await sendSMS();
    setTargetDate(Date.now() + 60 * 1000);
  };
  return (
    <div className="relative">
      <Input size="large" {...InputProps} />
      <div
        onClick={getSub}
        className="text-[#0CBF9F] absolute top-2 right-4 cursor-pointer"
      >
        {countdown === 0
          ? i18n('getCode')
          : `${Math.round(countdown / 1000)} s`}
      </div>
    </div>
  );
};
